<template>
  <div>
    <BranchForm :id="id" :visible="visible" />
  </div>
</template>

<script>
import BranchForm from "../component/branchForm.vue";
export default {
  name: "CreateBranch",
  components: { BranchForm },
  data() {
    return {
      id: 0,
      visible: false,
    };
  },
  mounted() {
    this.visible = true;
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
